<template>
  <div class="ts-px-2">
    <div
      class="ts-border-2 ts-border-dashed ts-p-2 ts-rounded-md ts-w-full ts-overflow-hidden hover:ts-border-blue-400 ts-duration-200 ts-cursor-pointer"
      @click="onClickShowStudent"
    >
      <div
        class="ts-flex ts-space-x-5 ts-whitespace-no-wrap"
        v-show="hasSelectedStudent"
      >
        <div style="min-width: 100px;">
          <img :src="displayPhoto" alt="" class="ts-h-20 ts-rounded-md" />
        </div>
        <div style="min-width: 200px;">
          <label class="ts-text-gray-500">{{
            $t('paymentNotice.studentName')
          }}</label>
          <p>
            <strong>{{ student.full_name_en || '-' }}</strong>
          </p>
          <p>{{ student.card_number || '-' }}</p>
          <p>{{ student.gender || '-' }}</p>
        </div>
        <div>
          <label class="ts-text-gray-500">{{
            $t('paymentNotice.department')
          }}</label>
          <p>{{ student.acp_name_foreign || '-' }}</p>
        </div>
        <div>
          <label class="ts-text-gray-500">{{
            $t('paymentNotice.major')
          }}</label>
          <p>{{ student.acps_name_foreign || '-' }}</p>
        </div>
      </div>
      <div
        v-show="!hasSelectedStudent"
        class="ts-flex ts-items-center ts-justify-center ts-duration-300 ts-rounded-md"
      >
        <div class="ts-text-center">
          <i
            class="fas fa-user-graduate fa-4x ts-py-2 ts-px-4 ts-rounded-lg ts-bg-blue-100 ts-text-blue-500"
          ></i>
          <h1 class="ts-font-semibold ts-mt-3">
            {{ $t('paymentNotice.clickHereToBrowseStudent') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="ts-border ts-rounded-md ts-p-2 ts-mt-2 ts-space-y-2">
      <div class="row">
        <div class="col-md-3 col-xs-12">
          <label class="required">{{ $t('paymentNotice.degree') }}</label>
          <a-select
            style="width: 100%"
            v-model="model.level_id"
            :options="levels"
            @change="onLevelChange"
          ></a-select>
          <div class="validate" v-if="errors.has('level_id')">
            {{ errors.first('level_id') }}
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <label class="required">{{ $t('paymentNotice.yearOfDegree') }}</label>
          <a-select
            style="width: 100%"
            v-model="model.grade_id"
            :options="grades"
            @change="onDegreeChange"
          ></a-select>
          <div class="validate" v-if="errors.has('grade_id')">
            {{ errors.first('grade_id') }}
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <label class="required">{{ $t('paymentNotice.year') }}</label>
          <a-select
            style="width: 100%"
            v-model="model.year"
            :options="years"
            disabled
          ></a-select>
          <div class="validate" v-if="errors.has('year')">
            {{ errors.first('year') }}
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <label class="required">{{ $t('paymentNotice.semester') }}</label>
          <a-select
            style="width: 100%"
            v-model="model.semester"
            :options="semesterLists"
          ></a-select>
          <div class="validate" v-if="errors.has('semester')">
            {{ errors.first('semester') }}
          </div>
        </div>
      </div>
      <div class="row" v-if="!refresh">
        <div class="col-md-3 col-xs-12">
          <label class="required">{{ $t('paymentNotice.studyTime') }}</label>
          <a-select
            v-model="model.ac_st_id"
            style="width: 100%"
            :options="studyTime"
            showSearch
            optionFilterProp="children"
            :filterOption="filterOption"
            @change="rebuild"
          ></a-select>
          <div class="validate" v-if="errors.has('ac_st_id')">
            {{ errors.first('ac_st_id') }}
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <label class="required">{{ $t('paymentNotice.term') }}</label>
          <a-select
            v-model="model.ac_term_id"
            style="width: 100%"
            :options="academicTerms"
            showSearch
            optionFilterProp="children"
            :filterOption="filterOption"
            @change="rebuild"
          ></a-select>
          <div class="validate" v-if="errors.has('ac_term_id')">
            {{ errors.first('ac_term_id') }}
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <label class="required">{{
            $t('paymentNotice.typeOfRegister')
          }}</label>
          <select v-model="model.is_new_student" class="form-control">
            <option value="">--select--</option>
            <option :value="1">{{ $t('paymentNotice.new') }}</option>
            <option :value="0">{{ $t('paymentNotice.old') }}</option>
          </select>
          <div class="validate" v-if="errors.has('is_new_student')">
            {{ errors.first('is_new_student') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import defaultImage from '@/assets/student-default-boy.png'
import { Errors } from 'form-backend-validation'
export default {
  name: 'academic',
  props: ['value', 'validate'],
  data() {
    return {
      student_has_invoice: [],
      levels: [],
      grades: [],
      studyTime: [],
      model: {},
      defaultImage,
      refresh: false,
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('paymentNoticeModule', ['selectedStudent', 'academicTerms']),
    years() {
      return [
        {
          value: 'YEAR I',
          label: 'YEAR I'
        },
        {
          value: 'YEAR II',
          label: 'YEAR II'
        },
        {
          value: 'YEAR III',
          label: 'YEAR III'
        },
        {
          value: 'YEAR IV',
          label: 'YEAR IV'
        }
      ]
    },
    semesters() {
      return [
        {
          value: 'SEMESTER I',
          label: 'SEMESTER I'
        },
        {
          value: 'SEMESTER II',
          label: 'SEMESTER II'
        }
      ]
    },
    semesterLists() {
      if (this.model.grade_id) {
        const semesterValues = this.student_has_invoice
          ? this.student_has_invoice.map(inv => inv.semester)
          : []
        if (semesterValues.length > 0) {
          return this.semesters.filter(el => !semesterValues.includes(el.value))
        } else {
          return this.semesters
        }
      }
      return this.semesters
    },
    student() {
      return this.selectedStudent
    },
    displayPhoto() {
      if (Object.keys(this.selectedStudent).length === 0) {
        return this.defaultImage
      }
      return this.selectedStudent.photo
        ? this.selectedStudent.photo
        : this.defaultImage
    },
    hasSelectedStudent() {
      return Object.keys(this.selectedStudent).length > 0
    }
  },
  methods: {
    ...mapActions('paymentNoticeModule', [
      'onGetLevel',
      'onGetGradeByLevel',
      'onCheckStudentHasPreInvoice',
      'onGetStudyTime',
      'onGetTerm'
    ]),
    ...mapMutations('paymentNoticeModule', [
      'SET_LOADING',
      'HIDE_SHOW_STUDENT_MODEL',
      'SET_TERM_LIST'
    ]),
    async fetchLevels() {
      this.levels = []
      return this.onGetLevel({
        acps_id: this.student.acps_id,
        level_id: this.selectedStudent
          ? this.selectedStudent.level_id.split(',').map(Number)
          : undefined
      }).then(response => {
        this.levels = response.data.data.map(el => ({
          value: el.level_id,
          label: el.level_name_foreign
        }))
      })
    },
    async fetchGrades() {
      this.grades = []
      return this.onGetGradeByLevel({
        level_id: this.model.level_id
      }).then(response => {
        this.grades = response.data.data.map(el => ({
          value: el.grade_id,
          label: el.grade_name_foreign,
          grade_order: el.grade_order
        }))
      })
    },
    async fetchTerm() {
      this.SET_TERM_LIST([])
      return this.onGetTerm({
        acps_id: this.student.acps_id,
        level_id: this.selectedStudent
          ? this.selectedStudent.level_id.split(',').map(Number)
          : undefined
      }).then(response => {
        const terms = response.data.data.map(el => ({
          value: el.ac_term_id,
          label: el.term_name,
          term_start: el.term_start,
          term_stop: el.term_stop
        }))
        this.SET_TERM_LIST(terms)
      })
    },
    async fetchStudyTime() {
      this.studyTime = []
      return this.onGetStudyTime().then(response => {
        this.studyTime = response.data.data.map(el => ({
          value: el.ac_st_id,
          label: `${el.study_time}-${el.session}`
        }))
      })
    },

    async onDegreeChange(value) {
      if (!this.grades.length) return
      const grade = this.grades.filter(el => el.value == this.model.grade_id)
      const gradeOrder = grade[0]['grade_order']
      this.model.year = this.years[gradeOrder - 1].value || ''
      this.model.semester = null
      this.model.inv_detail_list = []
      this.SET_LOADING(true)
      await this.onCheckStudentHasPreInvoice({
        student_id: this.model.student_id,
        grade_id: this.model.grade_id,
        year: this.model.year,
        semester: this.model.semester
      })
        .then(response => {
          this.student_has_invoice = response.data.data
          if (this.semesterLists.length > 0) {
            this.model.semester = this.semesterLists[0].value
          }
        })
        .finally(() => this.SET_LOADING(false))

      this.$emit('grade-change', value)
    },
    onClickShowStudent() {
      this.HIDE_SHOW_STUDENT_MODEL(true)
    },
    async onLevelChange() {
      this.SET_LOADING(true)
      this.model.year = undefined
      this.model.grade_id = undefined
      this.model.semester = undefined
      this.model.inv_detail_list = []
      this.model.ac_term_id = undefined
      await this.fetchGrades()
      await this.fetchTerm()
      this.$emit('level-change', this.model.level_id)
      this.SET_LOADING(false)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    rebuild() {
      this.refresh = true
      this.$nextTick(() => (this.refresh = false))
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
